import {history} from '../store/index';
import {store} from '../../NextApp';
import {generateQueryString} from "../../util/Api";

import {
  CREATE_MANPOWER_REMINDER_SUCCESS,
  FETCH_MANPOWER_REMINDER_SUCCESS,
  GET_MANPOWER_REMINDER_SUCCESS,
  SAVE_MANPOWER_REMINDER_QUERY,
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import {fetchError, fetchFilter, fetchStart, fetchSuccess,} from "./Common";
import {message} from "antd";


export const getResourceSuccess = ({data}) => {
  return {
    type: GET_MANPOWER_REMINDER_SUCCESS,
    data,
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_MANPOWER_REMINDER_QUERY,
    query
  };
};

export const createResourceSuccess = ({data}) => {
  return {
    type: CREATE_MANPOWER_REMINDER_SUCCESS,
    data
  };
};

export const fetchResourceSuccess = ({data}) => {
  console.log(`Here > - ${data}`);
  return {
    type: FETCH_MANPOWER_REMINDER_SUCCESS,
    data
  };
};

export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {documentType} = store.getState();
      const {query} = documentType;
      const response = await axios.get(`/manpower-reminder?${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      // message.error(error.response.data.message);
      // message.error("Record not found");
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const createResource = (payload, redirect = true, module, subMaster = false) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.post(`/manpower-reminder`, payload);
      if(response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      } else {
        dispatch(fetchSuccess());
        dispatch(createResourceSuccess({data: response.data}));
      }
      if(!redirect) {
        dispatch(fetchFilter(module));
      } else {
        history.push('/manpower-reminder');
        dispatch(getResource());
      }
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const updateResource = (payload, id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.put(`/manpower-reminder/${id}`, payload);
      if(response && response.data && response.data.code === 202) {
        message.error(response.data.message);
      }
      dispatch(fetchSuccess());
      history.push('/manpower-reminder');
      dispatch(getResource());
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error.response.data.message));
    }
  }
};

export const fetchResource = (id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      const response = await axios.get(`/manpower-reminder/${id}`);
      // console.log(`Here - ${response.data}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({data: response.data}));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const deleteResource = (id) => {
  return async (dispatch) => {
    dispatch(fetchStart());
    try {
      await axios.delete(`/manpower-reminder/${id}`);
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};
